export default function PageBody({ className = "", children, ...rest }: any) {
  return (
    <div style={{ marginTop: 30 }} className={`${className}`} {...rest}>
      {children}
    </div>
  );
}
